import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * The small hint lines shown between the photo reel and the shutter
 * bar (e.g. "add up to 3 photos…"). Hidden on very short screens by
 * theme/_scanner-layout.scss (owner decision #10).
 */
@Component({
  selector: 'cs-scanner-hints',
  templateUrl: 'cs-scanner-hints.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CsScannerHintsComponent {
  /** Hint lines as translation factories (each one is a function that
   *  calls a translation key when invoked) — resolved in the template
   *  so a runtime language switch stays reactive, the same as an
   *  inline translation-key call would be. */
  @Input() hints: (() => string)[] = [];
}
